<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateSeparation"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="bg-white rounded-md shadow-2xl sm:w-2/5 w-full center-h-v h-auto overflow-y-auto"
        >
          <el-tabs type="border-card">
            <form
              @submit.prevent="create"
              class="bg-white rounded-md w-full h-auto overflow-y-auto"
            >
              <div class="flex justify-between items-center border-b-1.5 p-3">
                <p class="text-base">Initiate Separation</p>
                <img
                  class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                  src="@/assets/icons/cross-white.png"
                  alt=""
                  @click="close()"
                />
              </div>
              <transition name="fade">
                <div
                  v-if="
                    info.StartDate &&
                    info.EndDate &&
                    dateDifference > info.PolicyDays &&
                    info.AnnualLeaveDaysBalance < 0
                  "
                >
                  <div
                    class="p-2 text-xs"
                    v-if="info.SeparationType === 'Resignation'"
                    and
                  >
                    <el-collapse accordion>
                      <el-collapse-item name="1">
                        <template slot="title">
                          Offset your effective date<i
                            class="header-icon el-icon-info"
                          ></i>
                        </template>
                        <div v-if="info.AnnualLeaveDaysBalance > 0">
                          <p class="p-2" style="font-size: 0.5rem">
                            You have {{ info.AnnualLeaveDaysBalance }} days of
                            available annual leave. You can use these days to
                            offset your resignation's effective date and resign
                            earlier than the policy days.
                          </p>
                          <div class="p-2">
                            <el-checkbox
                              v-model="offsetEffectiveDate"
                              @change="getMinimumDate"
                              >Offset Effective Date</el-checkbox
                            >
                          </div>
                        </div>
                        <div v-else-if="info.AnnualLeaveDaysBalance < 0">
                          <p class="p-2" style="font-size: 0.5rem">
                            Your annual leave balance is negative ({{
                              info.AnnualLeaveDaysBalance
                            }}
                            days). You might consider extending the effective
                            date to align with your available leave days.
                          </p>
                        </div>
                        <div v-else>
                          <p class="p-2" style="font-size: 0.5rem">
                            Your annual leave balance is zero. The policy days
                            will be applicable for your resignation's effective
                            date.
                          </p>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </transition>

              <transition name="fade">
                <div
                  v-if="loading"
                  class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
                >
                  <loader class="center-h-v" />
                </div>
              </transition>

              <transition name="fade">
                <div
                  v-if="create_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ create_error }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="create_success"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ create_success }}
                </div>
              </transition>
              <div class="grid grid-cols-1 p-4 gap-3">
                <div class="text-sm">
                  <label class="block pb-1">Separation Type</label>
                  <select
                    required
                    class="p-2 bg-gray-200 rounded-full w-full"
                    v-model="info.SeparationType"
                  >
                    <option
                      v-for="(type, index) in SeparationTypes"
                      :key="index"
                    >
                      {{ type.Name }}
                    </option>
                  </select>
                </div>

                <div
                  class="text-sm"
                  v-show="
                    info.SeparationType === 'Inactivate' ||
                    info.SeparationType === 'Suspension'
                  "
                >
                  <label class="block pb-1">Start Date</label>
                  <input
                    v-model="info.StartDate"
                    value="info.StartDate"
                    type="date"
                    class="p-2 bg-gray-200 rounded-full w-full"
                    placeholder="Start Date"
                    required
                  />
                </div>

                <div
                  class="text-sm"
                  v-show="
                    info.SeparationType === 'Inactivate' ||
                    info.SeparationType === 'Suspension'
                  "
                >
                  <label class="block pb-1">End Date</label>
                  <input
                    v-model="info.EndDate"
                    value="info.StartDate"
                    type="date"
                    class="p-2 bg-gray-200 rounded-full w-full"
                    placeholder="End Date"
                    required
                  />
                </div>

                <div
                  class="text-sm"
                  v-show="info.SeparationType === 'Termination'"
                >
                  <label class="block pb-1"
                    >Effective Date of {{ info.SeparationType }}</label
                  >
                  <input
                    v-model="info.TerminationDate"
                    type="date"
                    class="p-2 bg-gray-200 rounded-full w-full"
                    placeholder="Date of Termination"
                    required
                  />
                </div>

                <div
                  class="text-sm"
                  v-show="info.SeparationType === 'Resignation'"
                >
                  <label class="block pb-1"
                    >Effective Date of {{ info.SeparationType }}</label
                  >
                  <!--   :min="
                      new Date(minimuSelectableDate).toISOString().split('T')[0]
                    " -->
                  <input
                    v-model="info.StartDate"
                    type="date"
                    class="p-2 bg-gray-200 rounded-full w-full"
                    placeholder="Date of Termination"
                    required
                  />
                </div>

                <div
                  class="text-sm pt-4"
                  v-show="info.SeparationType === 'Resignation'"
                >
                  <!--  :min="
                      new Date(minimuSelectableDate).toISOString().split('T')[0]
                    " -->
                  <label class="block pb-1"
                    >Effective End Date of {{ info.SeparationType }}</label
                  >
                  <input
                    v-model="info.EndDate"
                    type="date"
                    class="p-2 bg-gray-200 rounded-full w-full"
                    placeholder="Date of Termination"
                    required
                  />
                </div>
              </div>
              <div class="p-4">
                <label>Attachment</label>
                <input
                  v-on:change="getFile"
                  type="file"
                  accept=".pdf,image/jpeg,image/png"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Leave Type"
                  :required="info.SeparationType === 'Resignation'"
                />
              </div>
              <div class="p-4">
                <label> Comment</label>
                <textarea
                  v-model="info.Reason"
                  class="p-1 bg-gray-200 rounded-xl w-full"
                  cols="5"
                  rows="5"
                ></textarea>
              </div>
              <div class="flex justify-end p-5">
                <button
                  @click="create"
                  class="bg-primary rounded-full px-10 text-sm text-white py-2"
                >
                  Submit
                </button>
              </div>
            </form>
          </el-tabs>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import axios from "axios";

export default {
  name: "Separation",
  components: { Loader },
  props: ["showCreateSeparation", "close"],
  data() {
    return {
      currentEmployeeBenefits: [],
      title: "Separation",
      SeparationTypes: [],
      create_success: null,
      create_error: null,
      loading: false,
      info: {
        Reason: "",
        SeparationType: "",
        SeparationTypeId: "",
        StartDate: "",
        EndDate: "",
        TerminationDate: "",
        EmployeeId: "",
        Attachment: "",
        EffectiveDate: "",

        AnnualLeaveDaysBalance: -10,
        PolicyDays: 10,
      },
      minimuSelectableDate: new Date(),
      offsetEffectiveDate: false,
      daysToffSet: 0,
    };
  },
  computed: {
    dateDifference() {
      if (this.info.SeparationType === "Resignation") {
        const startDate = new Date(this.info.StartDate);
        const endDate = new Date(this.info.EndDate);

        // Calculate the difference in milliseconds
        const difference = endDate - startDate;

        // Convert the difference to days
        const daysDifference = Math.floor(difference / (1000 * 60 * 60 * 24));

        return daysDifference;
      }

      return null;
    },

    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserRole",
      "getCurrentEmployeeId",
    ]),
  },
  created() {
    this.getSeparationTypes();
    this.getMinimumDate();
  },

  methods: {
    open() {
      this.$notify.info({
        title: "Info",
        message: `You effective date has been offset by ${this.daysToffSet} days`,
      });
    },

    // getMinimumDate() {
    //   const currentDate = new Date();

    //   if (this.offsetEffectiveDate) {
    //     this.daysToffSet = this.info.AnnualLeaveDaysBalance;
    //     this.open();
    //   } else {
    //     this.daysToffSet = 0;
    //   }

    //   this.minimuSelectableDate = new Date(
    //     currentDate.getTime() +
    //       (this.info.PolicyDays - this.daysToffSet) * 24 * 60 * 60 * 1000
    //   );
    // },
    getFile({ target }) {
      const file = target.files[0];
      this.info.Attachment = file;
    },
    handleClose() {
      this.showAddAsset = false;
    },
    setTab() {},

    create() {
      this.loading = true;

      this.info.SeparationTypeId = this.SeparationTypes.find(
        (separation) => separation.Name === this.info.SeparationType
      ).SeparationTypeId;

      const formData = new FormData();
      formData.append("Reason", this.info.Reason);
      formData.append("SeparationType", this.info.SeparationType);
      formData.append("SeparationTypeId", this.info.SeparationTypeId);
      formData.append("StartDate", this.info.StartDate);
      formData.append("EndDate", this.info.EndDate);
      formData.append("TerminationDate", this.info.TerminationDate);
      formData.append("EmployeeId", this.getCurrentEmployeeId);
      formData.append("Attachment", this.info.Attachment);

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "multipart/form-data", // Set the Content-Type to multi-part form
        },
      };

      axios
        .post(
          `${this.getOrganization}/employee/separation/${this.$ApiVersion}/create`,
          formData,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              this.create_success = response.data.StatusMessage;
              (this.info = {
                Reason: "",
                SeparationType: "",
                SeparationTypeId: "",
                StartDate: "",
                EndDate: "",
                TerminationDate: "",
                EmployeeId: "",
                Attachment: "",
              }),
                this.$emit("closeOnSuccess");
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    getSeparationTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/separation/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.SeparationTypes = response.data.Data;
              if (this.getUserRole.toLowerCase() === "hrmanager") {
                this.SeparationTypes = this.SeparationTypes.filter(
                    (separation) => !separation.EmployeeInitiate
                );
              } else if (this.getUserRole.toLowerCase() === "employee") {
                this.SeparationTypes = this.SeparationTypes.filter(
                    (separation) => separation.EmployeeInitiate
                );
              }
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
